const THREE_DP_UNITS = ["kg", "kilogram", "l", "lt", "litre", "liter", "m", "mt", "metre", "meter"];

export const fmtQty4 = (n, unit) => {
    const num = Number(n);
    if (!Number.isFinite(num)) return "0";
    if (unit && THREE_DP_UNITS.includes(String(unit).trim().toLowerCase())) {
        return num.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    }
    return num.toLocaleString("tr-TR", { maximumFractionDigits: 3 });
};
